<template>
    <table
        :style="'min-width: ' + minWidth + ';'"
        cellspacing="1"
        cellpadding="7"
        border="1"
        summary="This table of logistic regression results has 9 columns variable name, variable level, sample size, beta coefficient, standard error, t-statistic, p-value for t-statistic, odds ratio, and 95% CI for each selected independent variable"
        class="table table-bordered"
    >
        <tbody>
            <tr>
                <th><div class="sr-only">No value</div></th>
                <th scope="col">Sample Size</th>
                <th scope="col">Beta</th>
                <th scope="col">Standard Error</th>
                <th scope="col">t-statistic</th>
                <th scope="col">p-value for t-statistic</th>
                <th scope="col">Odds Ratio</th>
                <th scope="col" style="min-width: 100px">
                    95% CI for Odds Ratio
                </th>
            </tr>
            <tr class="row-title">
                <td :colspan="9">
                    {{
                        reportModel.parms.dependentVariable.variable
                            .variableTitle
                    }}, Modeling category:
                    {{ reportModel.dependentModelCategory }}
                </td>
            </tr>
            <regression-row-old
                :variableRows="1"
                :isFirstRow="true"
                variableTitle="Intercept"
                categoryTitle="Intercept"
                :statistics="reportModel.interceptData"
            ></regression-row-old>
            <tr class="signif_p"></tr>
            <template v-for="independent in reportModel.independentModel">
                <tr class="row-title" v-bind:key="independent.key">
                    <td :colspan="9">{{ independent.title }}</td>
                </tr>
                <template v-for="level in independent.levels">
                    <regression-row
                        :level="level"
                        v-bind:key="level.key"
                    ></regression-row>
                </template>
            </template>
        </tbody>
    </table>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import commonModelHelper from '@/scripts/commonModelHelper';
import regressionRow from '@/components/logisticRegression/report/regressionRow';
import regressionRowOld from '@/components/logisticRegression/report/regressionRowOld';

export default {
    props: ['reportModel', 'minWidth', 'independent'],
    data: function () {
        var vm = this;
        return {
            years: commonModelHelper.getDisplayYearsWithAnd()
        };
    },
    components: {
        'regression-row': regressionRow,
        'regression-row-old': regressionRowOld
    },
    methods: {}
};
</script>

<style scoped>
div.column-title {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

tr th:not(:first-child) {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
}

tr th:nth-child(1) {
    width: 300px;
}

tr th:nth-child(2) {
    width: 140px;
}

tr th:nth-child(3) {
    width: 140px;
}

tr th:nth-child(4) {
    width: 140px;
}

tr th:nth-child(5) {
    width: 140px;
}

tr th:nth-child(6) {
    width: 140px;
}

tr th:nth-child(7) {
    width: 140px;
}

tr th:nth-child(8) {
    width: 200px;
}

.row-title {
    width: fit-content;
    background-color: #c1d5b0;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

table,
th {
    border: none !important;
}
</style>
